// src/apiConfig.js

// Alternar entre estas dos líneas según estés trabajando local o en producción
const BASE_URL = 'https://iump.pythonanywhere.com';
//const BASE_URL = 'http://localhost:8000';
//const BASE_URL = 'http://192.168.1.83:8000';

export const API_CONFIG = {
    BASE_URL,

    // --- RUTAS DE CONSULTA (LECTURA PÚBLICA) ---
    AVISOS_HOY: `${BASE_URL}/api/avisos/hoy/`,
    AVISOS_SEMANA: 'https://avisos-iump-concon.pages.dev/api/avisos',
    TRANSMISION_RECIENTE: `${BASE_URL}/api/transmision/ultima/`,
    LECCION_PROXIMA: `${BASE_URL}/api/lecciones/proxima/`,

    // --- RUTAS DE GESTIÓN (ADMIN / CRUD) ---
    // Estas requieren autenticación y CSRF Token
    AVISOS_CREAR: `${BASE_URL}/api/avisos/crear/`,
    AVISOS_EDITAR: (id) => `${BASE_URL}/api/avisos/${id}/editar/`,
    AVISOS_ELIMINAR: (id) => `${BASE_URL}/api/avisos/${id}/eliminar/`,

    // --- AUTENTICACIÓN Y SUSCRIPCIÓN ---
    LOGIN: `${BASE_URL}/api/auth/login/`,
    LOGOUT: `${BASE_URL}/api/auth/logout/`,
    SUSCRIBIR: `${BASE_URL}/api/suscribir/`,

    // --- EXTRAS ---
    PROXY_ESCUELA: `${BASE_URL}/api/proxy-escuela/`
};